import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

import { GlobalStoreProps } from "./Global.types";

const initialStates = {
  isMenuOpened: true,
  previousMenuState: true,
  isManagerLogin: false,
  // mainRef: { current: null },
};

export const useGlobalStore = create(
  devtools(
    persist<GlobalStoreProps>(
      (set, get): GlobalStoreProps => ({
        ...initialStates,
        toggleMenu: () => set(state => ({ isMenuOpened: !state.isMenuOpened })),
        closeMenu: () => set({ isMenuOpened: false }),
        openMenu: () => set({ isMenuOpened: true }),
        setMenuOpened: (isOpen: boolean) => set({ isMenuOpened: isOpen }),
        setPreviousMenuState: (isOpen: boolean) => set({ previousMenuState: isOpen }),
        restorePreviousState: () => {
          const { previousMenuState } = get();
          set({ isMenuOpened: previousMenuState });
        },
        setIsManagerLogin: (isManagerLogin: boolean) => set({ isManagerLogin: isManagerLogin }),
      }),
      {
        name: "global-store",
      }
    )
  )
);

const initializeStore = (state: GlobalStoreProps) => {};

initializeStore(useGlobalStore.getState());
